import { CrashStore } from './crashStore';
import { UserStore } from './userStore';
import { DoubleStore } from './doubleStore';
import { TowerStore } from './towerStore';
import { JackpotStore } from './jackpotStore';
import { WebsocketService, WebsocketGameService, SoundService, ModalService } from 'services';
import { HiloStore } from './hiloStore';
import { FruitsStore } from './fruitsStore';
import { TeenPattiExpressStore } from './teenPattiExpressStore';
import { LudoStore } from './ludoStore';
import { DragonTigerStore } from './dragonTigerStore';
import { RummyStore } from './rummyStore';
import { DiverStore } from './diverStore';
import { TabService } from 'services/tabService';
import NewDoubleStore from './newDoubleStore';

export class RootStore {
    public userStore: UserStore;
    // public doubleStore: DoubleStore;
    // public crashStore: CrashStore;
    // public towerStore: TowerStore;
    // public jackpotStore: JackpotStore;
    public websocketService: WebsocketService;
    public websocketGameService: WebsocketGameService;
    public modalService: ModalService;
    // public hiloStore: HiloStore;
    // public soundService: SoundService;
    // public fruitsStore: FruitsStore;
    // public teenPattiExpressStore: TeenPattiExpressStore;
    // public ludoStore: LudoStore;
    // public dragonTigerStore: DragonTigerStore;
    // public rummyStore: RummyStore;
    // public diverStore: DiverStore;
    public tabService: TabService;
    // public newDoubleStore: NewDoubleStore;

    constructor() {
        this.websocketService = new WebsocketService();
        this.websocketGameService = new WebsocketGameService();
        this.userStore = new UserStore(this);
        this.modalService = new ModalService();
        this.tabService = new TabService();

        // this.crashStore = new CrashStore(this);
        // this.doubleStore = new DoubleStore(this);
        // this.towerStore = new TowerStore(this);
        // this.jackpotStore = new JackpotStore(this);
        // this.hiloStore = new HiloStore(this);
        // this.soundService = new SoundService(this);
        // this.fruitsStore = new FruitsStore(this);
        // this.teenPattiExpressStore = new TeenPattiExpressStore(this);
        // this.ludoStore = new LudoStore(this);
        // this.dragonTigerStore = new DragonTigerStore(this);
        // this.rummyStore = new RummyStore(this);
        // this.diverStore = new DiverStore(this);
        // this.newDoubleStore = new NewDoubleStore(this);
    }
}
